'use client';

import React from 'react';

interface CookieSettingsLinkProps {
  onClick?: () => void;
  className?: string;
}

export default function CookieSettingsLink({ onClick, className = '' }: CookieSettingsLinkProps) {
  return (
    <button
      onClick={onClick}
      className={`text-sm text-gray-600 hover:text-blue-500 transition-colors underline hover:no-underline ${className}`}
    >
      Cookie Settings
    </button>
  );
}
